import { StepType } from '@de/types/enums';
import type {
  MultiQuestion,
  Question,
  SideRailConfigItem,
  Step,
} from '@de/types/types';

export function getSideRailConfigsForStep(
  step?: Step | null,
): SideRailConfigItem[] {
  if (!step) return [];

  const sideRailEnabledSteps =
    step.type === StepType.QUESTION || step.type === StepType.MULTI_QUESTION;

  if (!sideRailEnabledSteps) return [];

  return (step as Question | MultiQuestion).sideRailConfigs ?? [];
}

export function stepHasSideRailContent(step?: Step | null): boolean {
  return getSideRailConfigsForStep(step).length > 0;
}
